import React, { Component } from 'react'
import HttpServices from '../../../../utils/Http.services'
import SwitchInput from '../../../inputs/SwitchInput'
import TextInput from '../../../inputs/TextInput'
import CustomLoader from '../../../CustomLoader'
import { checkTranslation, translate } from '../../../../utils/useful'
import ButtonAnimated from '../../../buttons/ButtonAnimated'
import StagesManager from '../../../StagesManager'





export default class Topics extends Component {
    state = {
        permissions: [
            { title: "{{lang}}messenger.Send Messages" },
            { title: "{{lang}}messenger.Send Media" },
            { title: "{{lang}}messenger.Add Members" },
            { title: "{{lang}}messenger.Create Topics" },
            { title: "{{lang}}messenger.Pin Messages" },
            { title: "{{lang}}messenger.change Group info" },
        ],
        topic: "",
        isLoader: false,


    }

    componentDidMount() {
        // console.log('this.props.topics', this.props.topics)
    }

    createTopic = (messenger) => {
        let users = []
        let data = {}
        this.setState({ isLoader: true })
        if (this.form1) {
            console.log("is loader")
            users = this.form1.getForm()
            data.users = users
        }

        data.topic = this.state.topic
        data.messenger = messenger
        // console.log('data.messenger', messenger, this.state.topic)
        HttpServices.request('createTopic', data, (fetchResult, fetchError) => {
            console.log('data.messengerres', fetchResult)

            this.setState({ isLoader: false })
            if(fetchError){
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }


            if (fetchResult.info) {

                this.props.setTopic(fetchResult.info)

                this.props.closeTopic()
                // let topics = this.props.topics
                // let topic = fetchResult.info
                // topics.push(topic)
                // if (this.props.setData) {
                //     this.props.setData('topics', topics, 'Messenger')
                // }
            }


            // console.log('data.messengererr', fetchError)
        })

    }
    openSidebar = () => {
        this.sidebarView.openSidebar()
    }

    openFirstView = () => {
        this.firstView.showView()
    }

    changeValue = (key, value) => {
        this.setState({ [key]: value })
    }

    goToAddNew = () => {
        this.stageManager.changeStage('add')
    }


    render() {
        return (
            <div className='h-100'>

                <StagesManager ref={el => this.stageManager = el} fast={true}  >

                    <div stage={0} stageName='main'>
                        <div className='px-2 flexcb py-2 top-0' style={{ height: 50, borderBottom: "1px solid #eee", background: '#fff', position: 'sticky', zIndex: 1 }}>
                            <div className='flexc' >
                                <button className='flexcc br-20' style={{ height: 24, width: 24, backgroundColor: '#eee' }} onClick={() => this.props.closeTopic()}>
                                    <img width={20} src='/assets/icons/angle-right-black.svg' className='rtl-button' style={{ transform: 'rotate(180deg)' }} alt='' />
                                </button>
                                <p className='text-bold font-size-16 px-1' style={{}}>{translate('Conversation topics')}</p>
                            </div>

                        </div>
                        {/* <div className='flexcb px-2 py-3' style={{ borderBottom: "1px solid #ddd" }}>
                    <button className='flexc' onClick={() => this.props.changeStage("manage")}>
                        <img width={18} src='/assets/icons/arrow-left-blue.svg' className='rtl-button' />
                        <p className='font-size-12' style={{ color: "#0085ff" }}>{translate('messenger.Manage Group')}</p>
                    </button>
                    <div className='px-2'>
                        <p className='font-size-16 weight-500' style={{ color: "#222" }}>{translate('messenger.Permissions')}</p>
                    </div>
                </div> */}



                        {!this.state.isLoader ? (
                            <div className=''>

                                <div className='px-1 pt-2'>
                                    {/* <div className='px-2'>
                                        <p className='font-size-14 main-c2 weight-500'>{translate('messenger.Topics You have created before')}:</p>
                                    </div> */}
                                    <div className='d-flex flex-column w-100 pt-1 pb-3'>

                                        <div className='w-100 flexcb mt-0 px-2' >
                                            <p className='font-size-13 main-c7 mb-2' style={{}}>{translate('Manage your conversation topics here. You can also add new topics here')}</p>
                                        </div>

                                        <button className='text-start text-link px-2 mt-1 mb-1' onClick={() => this.goToAddNew()}>
                                            <p className='font-size-14 text-semibold '>{translate("Add new topic")}</p>
                                        </button>

                                        {this.props.topics.map((prop, index) => {
                                            return (
                                                <div className='bb-gray w-100'>
                                                    <button className='text-start my-1 px-2 py-2 hover-gray br-5 w-100' onClick={() => this.props.setMessenger(prop)}>
                                                        <div className=' w-100'>
                                                            <p className='font-size-14 text-semibold '>{checkTranslation(prop.name)}</p>
                                                        </div>
                                                    </button>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='h-100 flexcc'>
                                <CustomLoader color={"#007aff"} isLoading={true} />
                            </div>
                        )}
                    </div>


                    <div stage={1} stageName='add'>


                        <div className='px-2 flexcb py-2 top-0' style={{ height: 50, borderBottom: "1px solid #eee", background: '#fff', position: 'sticky', zIndex: 1 }}>
                            <div className='flexc' >
                                <button className='flexcc br-20' style={{ height: 24, width: 24, backgroundColor: '#eee' }} onClick={() => this.stageManager.changeStage('main')}>
                                    <img width={20} src='/assets/icons/angle-right-black.svg' className='rtl-button' style={{ transform: 'rotate(180deg)' }} alt='' />
                                </button>
                                <p className='text-bold font-size-16 px-1' style={{}}>{translate('Add Topic')}</p>
                            </div>
                            <div className='flexc'>

                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => this.createTopic(this.props.messenger._id)}
                                    title={translate('Add')}
                                    icon='/assets/icons/angle-right-white2.svg'
                                    textColor={'#fff'}
                                    bg={this.props.background ?? 'linear-gradient(to right, rgb(124, 122, 255), rgb(88, 86, 214))'}
                                    width={'100%'}
                                />
                            </div>
                        </div>

                        <div className='' style={{ borderBottom: "0px solid #eee" }}>
                            <div className=''>
                                {/* <p className='font-size-14' style={{ color: "#0085FF" }}>Title</p> */}
                                <div className='w-100 px-2 py-3'>


                                    <div className='w-100 flexcb mb-2 px-1' >
                                        <p className='font-size-14 text-semibold mb-1 required' style={{}}>{translate('Topic name')}</p>
                                    </div>

                                    <div className='flexcc w-100 br-10  px-2 py-2 big-text-input ' style={{ border: '1px solid #eee' }}>
                                        <TextInput data={this.state.topic} changeValue={this.changeValue} header={{ key: 'topic', information: { rows: 1, placeholder: translate('messenger.Topic Name') }, }} />
                                    </div>

                                    <div className='w-100 flexcb mt-2 px-1' >
                                        <p className='font-size-13 main-c7 mb-2' style={{}}>{translate('Select a name for the new topic then click on add button.')}</p>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>

                </StagesManager>
            </div>
        )
    }
}
